// extracted by mini-css-extract-plugin
export default {"serviceOfferingWeightsTitle":"service-offering-weights-container__service-offering-weights-title__iDe4E"};